import { useQuery } from '@tanstack/react-query'
import { getMyAttendanceAcrossCompanies } from '@/api/services/attendance.service'
import type { MyAttendanceFilterQueryDto } from '@/features/attendance/types/attendance.types'

const myAttendanceKeys = {
  list: (params?: MyAttendanceFilterQueryDto) =>
    ['attendance-me', params] as const,
}

export function useMyAttendance(
  params?: MyAttendanceFilterQueryDto,
  options?: { enabled?: boolean }
) {
  return useQuery({
    queryKey: myAttendanceKeys.list(params),
    queryFn: () => getMyAttendanceAcrossCompanies(params),
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
    enabled: options?.enabled !== false,
  })
}
